"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispatchesFields = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const form_panel_1 = require("../../../composite/form/fields/form-panel");
const identifier_1 = require("../common/identifier");
const ess_api_1 = require("../ess-api");
const form_select_1 = require("../../../composite/form/fields/form-select");
/**
 * fixme: add document, subject
 */
function DispatchesFields() {
    const methods = ess_api_1.useDispatchMethods();
    const states = ess_api_1.useDispatchStates();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(form_panel_1.FormPanel, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ESS_DISPATCHES_PANEL_TITLE", defaultMessage: "Vypraven\u00ED" }) },
            react_1.default.createElement(form_select_1.FormSelect, { name: "state", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ESS_DISPATCHES_FIELD_LABEL_STATE", defaultMessage: "Stav" }), valueIsId: true, source: states, tooltipMapper: (o) => o.name }),
            react_1.default.createElement(form_select_1.FormSelect, { name: "method", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ESS_DISPATCHES_FIELD_LABEL_METHOD", defaultMessage: "Type" }), valueIsId: true, source: methods, tooltipMapper: (o) => o.name })),
        react_1.default.createElement(identifier_1.Identifier, null)));
}
exports.DispatchesFields = DispatchesFields;
//# sourceMappingURL=dispatches-fields.js.map